module.exports = {
      id: "humoursatire-entertainment-usage",
      viewBox: "0 0 77 77",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#humoursatire-entertainment",
      toString: function () {
        return this.url;
      }
    }